const currencies = {
  CAD: "CAD",
  USD: "USD",
  NGN: "NGN",
  MTK: "MTK",
  USDT: "USDT",
  USDSymbol: "$",
  CADSymbol: "$",
  NGNSymbol: "₦",
  MTKSymbol: "MTK",
  USDTSymbol: "USDT"
}

const currencyToCurrencySymbolMap = {
  CAD: "CADSymbol",
  USD: "USDSymbol",
  NGN: "NGNSymbol",
  MTK: "MTKSymbol",
  USDT: "USDTSymbol"
};

const currentCurrency = currencies.MTK;

export {
  currencies,
  currentCurrency,
  currencyToCurrencySymbolMap
};